module.exports = __webpack_public_path__ + "static/4_environment-75e190a384d2687433ecbb47ce44f1d4.png";